import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Api } from '../interfaces';
import { objectToFormData } from '../services';

export abstract class BaseApi implements Api {
  protected server: string;

  constructor(private http: HttpClient, private jwtService: JwtService) {}

  private formatErrors(error: Error) {
    return throwError(error);
  }

  private headers = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': `application/json`
  }).append('Authorization', `Bearer ${this.jwtService.getToken()}`);

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${this.server}${path}`, {
        headers: this.headers,
        params: params
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }


  downloadFile(url : string): any {
		return this.http.get(url, {headers: this.headers, responseType: 'blob'});
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http
      .put(`${this.server}${path}`, JSON.stringify(body), {
        headers: this.headers
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.http
      .patch(`${this.server}${path}`, JSON.stringify(body), {
        headers: this.headers
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http
      .post(`${this.server}${path}`, JSON.stringify(body), {
        headers: this.headers
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }

  file(
    path: string,
    file: File,
    body: Object = {},
    fileName: string = 'document'
  ): Observable<any> {
    let formData: FormData;
    if (Object.keys(body).length === 0) {
      formData = new FormData();
    } else {
      formData = objectToFormData(body);
    }
    formData.append(fileName, file, file.name.split('.')[0]);
    return this.http.post(`${this.server}${path}`, formData).pipe(
      catchError(this.formatErrors),
      map((res: Response) => res)
    );
  }


  delete(path): Observable<any> {
    return this.http
      .delete(`${this.server}${path}`, {
        headers: this.headers
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }

  /** 
   * Backend Sign In
   */

  login(body){
    return this.http.post(`http://10.247.10.199:20000/ecosure-portal-backend/api/v0/auth/login`,body).pipe(
      catchError(this.formatErrors),
      map((res: Response) => res)
    )
  }

  /**
   * * KEY-CLOAK SIGN IN USER METHOD
   */
  key_post(path: string, body: Object = {}): Observable<any> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    /**
     * TODO: remove body.toString() replace with JSON.stringify(body)
     */
    const options = { headers: headers };
    return this.http
      .post(`${this.server}${path}`, body.toString(), options)
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }

  /**
   * * KEY-CLOAK GET USER DETAILS AND ROLES METHOD
   */
  key_get(path: string, options): Observable<any> {
    return this.http
      .get(`${this.server}${path}`, {
        headers: this.headers
      })
      .pipe(
        catchError(this.formatErrors),
        map((res: Response) => res)
      );
  }
}
